import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import Accordion from '../../misc/Accordion';

import FieldListTypes from '../../../constants/FieldListTypes';
import DefaultFieldListOptions from '../../../constants/DefaultFieldListOptions';
import ThemeContext from '../../../theme/ThemeContext';

import FieldListItem from './FieldListItem';

const StyledFieldListWrapper = styled.div` 
  display: flex;
  flex-direction: column;
  flex: 1;
  max-height: ${(props) => props.height}px;
  overflow-y: scroll;
`;

const StyledFieldWrapper = styled.div``;

const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledLabel = styled.div`
  display: flex;
  flex: 1;
  font-weight: 600;
  font-size: 14px;
  color: ${(props) => props.theme.fontColorPrimary};
`;

const StyledContent = styled.div`
  flex: 1;
  overflow: hidden;
  padding: 8px;
  padding-top: 0px;
`;

const FieldList = ({ fields = DefaultFieldListOptions, height }) => {

  const fieldNodes = [];

  fields.forEach((field, i) => {

    if (!field || !field?.type) return null;

    if (field.type === FieldListTypes.fieldGroup) {
      fieldNodes.push(
        <FieldGroup
          key={i}
          title={field.title}
          fields={field.fields}
          display={field.open}
        />
      );
    } else {
      fieldNodes.push(
        <StyledFieldWrapper key={i}>
          <FieldListItem
            type={field.type}
            iconType={field.iconType}
            icon={field.icon}
            title={field.title}
            description={field.description}
            field={field}
            fields={fields}
            extraStyles={{
              padding: '5px 10px'
            }}
          />
        </StyledFieldWrapper>
      );
    }
  });

  return (
    <StyledFieldListWrapper height={height}>
      {fieldNodes}
    </StyledFieldListWrapper>
  );

};

export const FieldGroup = ({ title, display, fields }) => {

  const [open, setOpen] = useState(display);
  const theme = useContext(ThemeContext);

  const fieldNodes = fields.map((field, i) => {

    return (
      <StyledFieldWrapper key={i}>
        <FieldListItem
          type={field.type}
          iconType={field.iconType}
          icon={field.icon}
          title={field.title}
          description={field.description}
          field={field}
          extraStyles={{
            padding: '5px 10px'
          }}
        />
      </StyledFieldWrapper>
    );
  });

  return (
    <StyledFieldWrapper>
      <Accordion
        isOpen={open}
        onClick={() => setOpen(!open)}
        title={(
          <StyledHeader>
            <StyledLabel theme={theme}>{title}</StyledLabel>
          </StyledHeader>
        )}
        extraStyles={{
          border: '0.5px groove #E2E3E7',
          padding: '20px',
          borderBottom: '0px',
          borderRadius: '0px'
        }}
      >
        <StyledContent>
          {fieldNodes}
        </StyledContent>
      </Accordion>
    </StyledFieldWrapper>
  );

};

export default FieldList;
